import { Signal } from '@/gen/inventory/v1/signal_pb'
import { GetSignalResponse } from '@/gen/inventory/v1/signal_service_pb'

import { WHY_THIS_MATTERS_LABEL } from '@/const/label'

import { InstanceAlertTable } from './instance-alert-table'

type ControlGapSignalDetailsProps = {
  signals: GetSignalResponse[]
}

export const ControlGapSignalDetails = ({ signals }: ControlGapSignalDetailsProps) => {
  if (signals.length === 0) {
    return null
  }

  const firstSignalMessage = signals[0]
  const firstSignal = firstSignalMessage?.signal
  const allSignals = signals.map((s) => s.signal).filter(Boolean) as Signal[]

  return (
    <div key={firstSignal?.id}>
      <span className='text-xs'>Signal</span>
      <div className='mb-8 text-lg font-bold'>{firstSignal?.title}</div>
      <div className='mt-7'>
        <div className='my-3'>
          <span className='font-bold'>Description:</span>
          <span>{firstSignalMessage?.detail?.documentation?.description}</span>
        </div>
        <div className='my-3'>
          <span className='font-bold'>{WHY_THIS_MATTERS_LABEL}</span>
          <span>{firstSignalMessage?.detail?.documentation?.risk}</span>
        </div>
      </div>
      <InstanceAlertTable signals={allSignals} />
    </div>
  )
}
